<script>
import SettingsMenu from '@/components/leads/settings/Menu.vue'

export default {
  components: {
    'mia-settings-menu': SettingsMenu
  },

  mounted() {
    window.eventBus.$emit('mia-loading-ended')
    window.eventBus.$emit('mia-set-breadcrumb', [
      {
        link: {
          path: '/lead/dashboard'
        },
        text: 'Leads'
      },
      {
        link: {
          path: '/leads/settings'
        },
        text: 'Einstellungen'
      }
    ])
  }
}
</script>

<template>
  <div class="w-full">
    <h1 class="my-0 py-0">
      Lead-Einstellungen
    </h1>
    <div
      class="mt-1 w-full max-w-sm"
      style="height: 2px; background: linear-gradient(90deg, rgba(245,130,31,1) 0%, rgba(245,130,31,0) 100%);"
    />

    <div class="flex">
      <div class="flex-shrink-0 w-56">
        <mia-settings-menu class="sticky top-0" />
      </div>

      <div class="flex-1 ml-8 pt-4">
        <router-view />
      </div>
    </div>
  </div>
</template>
